module.exports = __webpack_public_path__ + "html/week6_6b254876f39cd16354fe0f0e83084ab3.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/education/week6.html
// module id = Oquy
// module chunks = 55